//material-ui
import { Card, CardContent, Grid, GridProps as GridProps } from "@mui/material";

const SelectCard: React.FC<GridProps & React.ComponentProps<typeof Grid>> = ({ children, ...props }) => {
	return (
		<Card
			sx={{
				backgroundColor: (theme) => theme.palette.selectCard.main,
				cursor: "pointer",
				marginBottom: 1
			}}
			variant="outlined"
		>
			<CardContent sx={{ padding: 1 }}>
				<Grid
					alignItems="stretch"
					container
					direction="row"
					spacing={0}
					{...props}
					sx={{
						height: "100%"
					}}
				>
					{children}
				</Grid>
			</CardContent>
		</Card>
	);
};

export default SelectCard;
